import * as RadixContextMenu from '@radix-ui/react-context-menu';
import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type ContextMenuLabelProps = RadixContextMenu.ContextMenuLabelProps;

export const ContextMenuLabel = memo(({ className, ...restOfProps }: ContextMenuLabelProps) => {
  return (
    <RadixContextMenu.Label
      className={cn('px-1.5 font-bold text-12 text-gray-10 uppercase tracking-wide', className)}
      data-testid="CONTEXT_MENU_LABEL"
      {...restOfProps}
    />
  );
});

ContextMenuLabel.displayName = 'ContextMenuLabel';
